import { Link, Tooltip } from "@amzn/storm-ui";

import {
    getAdvertiserId,
    getMarketplaceId,
    isScopedToAccount,
} from "../../utils/permission.utils";

export const ICM_LINK_TOOLTIP_MESSAGE =
    "Customize brand-level insights by redefining brands using browse nodes/ASINs and selecting peer brands";

export const ICM_LINK_LABEL = "Insights Configuration";

export const IcmLink: React.FC = () => {
    const marketplaceId = getMarketplaceId();
    const sfId = getAdvertiserId();

    return (
        <Tooltip
            transitionDuration={0}
            withCloseButton={false}
            trigger={
                <Link
                    target="_blank"
                    href={`/icm?sfId=${sfId}&marketplaceId=${marketplaceId}`}
                    disabled={!isScopedToAccount()}
                    external
                    data-testid="icm-link"
                >
                    {ICM_LINK_LABEL}
                </Link>
            }
            message={ICM_LINK_TOOLTIP_MESSAGE}
        />
    );
};
